import { render, staticRenderFns } from "./ShiftsCounterWrapper.vue?vue&type=template&id=191a264a&"
import script from "./ShiftsCounterWrapper.vue?vue&type=script&lang=js&"
export * from "./ShiftsCounterWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports